import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const MinusCircleIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.81601 8.00041C0.81601 11.9604 4.04001 15.1844 8.00001 15.1844C11.96 15.1844 15.184 11.9604 15.184 8.00041C15.184 4.04041 11.96 0.816406 8.00001 0.816406C4.04001 0.816406 0.81601 4.04041 0.81601 8.00041ZM1.75201 8.00041C1.75201 4.55241 4.55201 1.75241 8.00001 1.75241C11.448 1.75241 14.248 4.55241 14.248 8.00041C14.248 11.4484 11.448 14.2484 8.00001 14.2484C4.55201 14.2484 1.75201 11.4484 1.75201 8.00041Z"
        fill="#657B74"
      />
      <rect x="4.8" y="7.4" width="6.4" height="1.2" rx="0.6" fill="#657B74" />
    </IconSvgWrapper>
  );
};

export default MinusCircleIcon;
